/**
 * Длительность видеофайла, не отправляя его на сервер.
 *
 * Файл уже лежит в браузере — тот умеет прочитать заголовок сам, и спрашивать
 * длительность у куратора незачем: он её не знает и лезет смотреть свойства
 * файла, а ошибётся — клиентка увидит в карточке неправду.
 *
 * Отказ — не беда: поле остаётся пустым, и его по-прежнему можно заполнить
 * руками. Форматов, которые браузер не открывает, хватает.
 */
export function videoDurationSec(file) {
  return new Promise((resolve) => {
    if (!file || !file.type || file.type.indexOf('video/') !== 0) {
      resolve(null);
      return;
    }

    const url = URL.createObjectURL(file);
    const probe = document.createElement('video');

    const finish = (seconds) => {
      // Ссылку освобождаем в обоих исходах: она держит файл в памяти вкладки,
      // а файлы здесь по четверти гигабайта
      URL.revokeObjectURL(url);
      resolve(seconds);
    };

    probe.preload = 'metadata';
    probe.onloadedmetadata = () => {
      const seconds = probe.duration;
      finish(isFinite(seconds) && seconds > 0 ? Math.round(seconds) : null);
    };
    probe.onerror = () => finish(null);
    probe.src = url;
  });
}
